import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { currentUser, isAdmin, loading } = useAuth();
  const storedMockUser = JSON.parse(
    localStorage.getItem("mockUser") || sessionStorage.getItem("mockUser") || "null"
  );
  const hasStoredAdminSession =
    storedMockUser?.uid === "hardcoded-admin" && storedMockUser?.role === "admin";

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="rounded-2xl bg-white px-6 py-5 shadow-sm text-sm text-slate-600">
          Loading admin dashboard...
        </div>
      </div>
    );
  }

  if (!currentUser && !hasStoredAdminSession) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin && !hasStoredAdminSession) {
    return <Navigate to="/" replace />;
  }

  return children;
}
